import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { tabSearch } from "@/app/tabs";
import { CatalogueScreen } from "@/features/catalogue";
import { requirePerm } from "@/lib/auth/guards";

/**
 * `/catalogue` — the drug-product list beside the detail pane, one surface.
 *
 * `GET /v1/drug/products` (23-10-2026 09:46 UTC) is parsed and drawn in
 * `features/catalogue` (`DECISIONS.md` 25-10-2026). The document adds no
 * other catalogue operation: no pricing read, so the price list is not
 * drawn, and no write, so nothing on the screen sends one.
 *
 * THE ADDRESS IS `/catalogue` AND NOTHING AFTER IT. The two section ids were
 * Inventory's until the POC moved them, and an old `?tab=products`,
 * `?tab=pricing` or `?tab=formulary` still has to leave the shelf for here
 * (`/inventory`'s route) — then the query is dropped and all three open this
 * one list. The open row is memory on the screen, never on the address
 * (`app/tabs.ts`, `app/module-address.ts`).
 *
 * `VIEW_INVENTORY` and not a right of its own: it is what opens the shelf AND
 * the list of what may go on it. See `app/nav.ts`.
 */
export const Route = createFileRoute("/_authenticated/catalogue")({
  // Its own vocabulary, so an old `?tab=formulary` still resolves — retired
  // once when the product list stopped being only medicines, and again when
  // it left the shelf. The address that remains is `/catalogue`. `app/tabs.ts`.
  validateSearch: tabSearch("catalogue"),
  beforeLoad: (args) => {
    replaceWithBareModule("/catalogue", args.location);
    requirePerm("VIEW_INVENTORY")(args);
  },
  component: CatalogueScreen,
});
